class ShippingBar {
constructor() {
    this.container = document.querySelector('.shipping-bar-container');
    if (!this.container) return;
    // Get threshold from data attribute
    this.threshold = parseInt(this.container.dataset.threshold) || 10000;
    this.messageElement = this.container.querySelector('[data-free-shipping-message]');
    this.progressBar = this.container.querySelector('[data-progress-bar]');
    
    // Listen for Shopify's cart changes
    document.addEventListener('cart:refresh', this.handleCartUpdate.bind(this));
    document.addEventListener('cart:change', this.handleCartUpdate.bind(this));
    document.addEventListener('product:added', this.handleCartUpdate.bind(this));
    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
    
    // Initial cart fetch
    this.handleCartUpdate();
    
    // Setup fetch listener
    this.setupFetchListener();
}
handleCartUpdate() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        // Only show and update if there are items in the cart
        if (cart.item_count > 0) {
        this.updateProgress(cart.total_price);
        } else {
        this.container.classList.add('shipping-bar--hidden');
        }
    })
    .catch(error => console.error('Error fetching cart:', error));
}
setupFetchListener() {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    
    const url = args[0].url || args[0];
    
    if (typeof url === 'string' && 
        (url.includes('/cart/add') || 
        url.includes('/cart/change') || 
        url.includes('/cart/update') ||
        url.includes('/cart/clear'))) {
        setTimeout(() => this.handleCartUpdate(), 100);
    }
    
    return response;
    };
}
updateProgress(cartTotal) {
    if (!this.container) return;
    // Hide the bar if cart is empty
    if (cartTotal === 0) {
    this.container.classList.add('shipping-bar--hidden');
    return;
    } else {
    this.container.classList.remove('shipping-bar--hidden');
    }
    if (cartTotal >= this.threshold) {
    this.container.innerHTML = `
        <div class="shipping-bar shipping-bar--success">
        <span class="h5"></span>
        </div>
    `;
    } else {
    const remaining = this.threshold - cartTotal;
    const percentage = (cartTotal * 100) / this.threshold;
    let message = `Add ${this.formatMoney(remaining)} more for free shipping`;
    // Create the new content but keep the progress bar separate
    const progressBar = this.container.querySelector('.progress-bar');
    
    if (progressBar) {
        // If progress bar exists, update its width with animation
        progressBar.style.width = `${percentage}%`;
        
        // Update the message separately to avoid disrupting the animation
        const messageEl = this.container.querySelector('.h5');
        if (messageEl) {
        messageEl.textContent = message;
        }
    } else {
        // If no progress bar exists, create the entire content
        this.container.innerHTML = `
        <div class="shipping-bar shipping-bar--progress">
            <span class="h5">${message}</span>
            <div class="progress">
            <div class="progress-bar" style="width: ${percentage}%"></div>
            </div>
        </div>
        `;
    }
    }
}
formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'AUD'
    });
}
}
// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
new ShippingBar();
}); 